import codes from "../../errorCodes/Saga"

export default function sagaErrorHandler(code: string) {
  switch (code) {
    case codes.DynamoAdapterWriteError:
      return "errors.PBSAGDynamoAdapterWriteError"
    case codes.DynamoAdapterReadError:
      return "errors.PBSAGDynamoAdapterReadError"
    case codes.RestAdapterRequestException:
      return "errors.PBSAGRestAdapterRequestException"
    case codes.RestAdapterInvalidEndpoint:
      return "errors.PBSAGRestAdapterInvalidEndpoint"
    case codes.RestAdapterNoEndpointSet:
      return "errors.PBSAGRestAdapterNoEndpointSet"
    case codes.SagaLogInvalidEntry:
      return "errors.PBSAGSagaLogInvalidEntry"
    case codes.SagaLogInvalidState:
      return "errors.PBSAGSagaLogInvalidState"
    case codes.RedemptionFlowInvalidSagaStatus:
      return "errors.PBSAGRedemptionFlowInvalidSagaStatus"
    case codes.SagaNotFound:
      return "errors.PBSAGSagaNotFound"
    case codes.SagaNotFoundForPayment:
      return "errors.PBSAGSagaNotFoundForPayment"
    case codes.SagaForbiddenNotOwner:
      return "errors.PBSAGSagaForbiddenNotOwner"
    case codes.TokenMissing:
      return "errors.PBSAGTokenMissing"
    case codes.PaymentNotRequired:
      return "errors.PBSAGPaymentNotRequired"
    case codes.PaymentCannotCompleteSagaAborted:
      return "errors.PBSAGPaymentCannotCompleteSagaAborted"
    case codes.Payment3DSInputRequired:
      return "errors.PBSAGPayment3DSInputRequired"
    case codes.StockIssue:
      return "errors.PBSAGStockIssue"
    case codes.InvalidJsonRequest:
      return "errors.PBSAGInvalidJsonRequest"
    case codes.InvalidRequesMissingOrUnexpectedFields:
      return "errors.PBSAGInvalidRequesMissingOrUnexpectedFields"
    case codes.InvalidRequestEmail:
      return "errors.PBSAGInvalidRequestEmail"
    case codes.StepCannotStartSagaAborted:
      return "errors.PBSAGStepCannotStartSagaAborted"
    case codes.StepNotRequired:
      return "errors.PBSAGStepNotRequired"
    case codes.StepPreviousStepNotCompleted:
      return "errors.PBSAGStepPreviousStepNotCompleted"
    case codes.StepStepAlreadyCompleted:
      return "errors.PBSAGStepStepAlreadyCompleted"
    case codes.PaymentAlreadyStarted:
      return "errors.PBSAGPaymentAlreadyStarted"
    case codes.PaymentSuspectedAsRefused:
      return "errors.PBSAGPaymentSuspectedAsRefused"
    case codes.PBSAGNotEnoughTT:
      return "errors.PBSAGNotEnoughTT"
    case codes.PBSAGLegacyRLOTFallbackLimit:
      return "errors.PBSAGLegacyRLOTFallbackLimit"
    case codes.PBSAGLegacyRLOTFallbackOpenValue:
      return "errors.PBSAGLegacyRLOTFallbackOpenValue"
    case codes.PBSAGLegacyRLOTFallbackEventWindow:
      return "errors.PBSAGLegacyRLOTFallbackEventWindow"
    case codes.PBSAGLegacyRLOTFallbackTotalPrice:
      return "errors.PBSAGLegacyRLOTFallbackTotalPrice"
    case codes.CreatePaymentFailed:
      return "errors.PBCTACreatePaymentFailed"
    default:
      return ""
  }
}
